import React from 'react';
import dubaiPoliceLogo from '../../assets/dubai-police-logo.png';

const ResultScreen = ({ generatedImage, styleName, onRetake, onNext }) => {
  return (
    <div className="h-screen relative overflow-hidden bg-gradient-to-b from-white via-[#F6FBF9] to-[#E4EFEA]">
      {/* Vertical spine */}
      <div className="forensic-spine" />

      {/* Background layers */}
      <div className="forensic-grid-overlay opacity-15" />
      <div className="forensic-map-overlay opacity-[0.04]" />
      <div className="forensic-circuit-lines" />

      {/* Green blocks */}
      <div className="forensic-block forensic-block-2 opacity-60" />
      <div className="forensic-corner-tl" />

      {/* Main content */}
      <div className="relative z-10 h-full flex flex-col">
        {/* Compact Header */}
        <header className="flex justify-between items-center px-8 py-3 flex-shrink-0">
          <div className="pl-4">
            <h1 className="text-lg font-bold tracking-[0.1em] uppercase text-[#1A1A1A]">{styleName}</h1>
            <p className="text-[10px] tracking-[0.15em] uppercase text-[#6B7770] font-arabic">
              نتيجة التحويل
            </p>
          </div>
          <img src={dubaiPoliceLogo} alt="Dubai Police" className="h-10 w-auto" />
        </header>

        {/* Header line */}
        <div className="h-[2px] mx-8 bg-gradient-to-r from-[#0e734b] via-[#0e734b] to-transparent flex-shrink-0" style={{ backgroundSize: '40% 100%', backgroundRepeat: 'no-repeat' }} />

        {/* Breathing space - pushes buttons down to ergonomic height */}
        <div className="flex-shrink-0 py-4"></div>

        {/* Action buttons - Bilingual - Above image for easy reach */}
        <div className="flex-shrink-0 px-8 py-3">
          <div className="flex gap-4 justify-center">
            <button
              onClick={onRetake}
              className="forensic-btn-secondary px-10 py-4 text-base flex items-center gap-2"
            >
              <span>←</span>
              <span className="font-title uppercase">Retake</span>
              <span className="opacity-60">|</span>
              <span className="font-arabic">إعادة</span>
            </button>
            <button
              onClick={onNext}
              className="forensic-btn-primary px-14 py-5 text-lg flex items-center gap-3"
            >
              <span className="font-title uppercase font-bold">Get QR</span>
              <span className="text-white/60">|</span>
              <span className="font-arabic font-bold">احصل على الرمز</span>
              <span>→</span>
            </button>
          </div>
        </div>

        {/* Status indicator */}
        <div className="flex items-center justify-center gap-2 text-[#6B7770] text-[10px] uppercase tracking-[0.2em] flex-shrink-0 py-2">
          <div className="w-2 h-2 bg-[#0e734b] rounded-sm" />
          <span>AI Transformation Complete</span>
          <div className="w-2 h-2 bg-[#0e734b] rounded-sm" />
        </div>

        {/* Image display - Takes remaining space at bottom */}
        <main className="flex-1 flex items-center justify-center min-h-0 px-8 pb-6">
          <div className="relative h-full max-h-full flex items-center justify-center">
            <div className="forensic-card p-3 h-full flex items-center justify-center" style={{ aspectRatio: '2/3' }}>
              <img
                src={generatedImage}
                alt="Transformed result"
                className="max-w-full max-h-full w-auto h-auto object-contain rounded-sharp border-2 border-[#0e734b]/20"
              />
            </div>
          </div>
        </main>

      </div>
    </div>
  );
};

export default ResultScreen;
